import type { IMessageWriter } from '../../../engine/messageWriter'
import { messageWriter } from '../../../engine/messageWriter-sidecar'
import { websockets } from '../../../engine/websockets-sidecar'
import { assert } from '../../../lib/assert-sidecar'
import { chessGameManager } from '../chessGameManager-sidecar'
import { chessGameMode_game } from '../chessGameMode_game-sidecar'
import { chessGameRules } from '../chessGameRules-sidecar'
import { chessUiGame } from '../ui/chessUiGame-sidecar'
import { EChessMessage } from './chessMessageIds'

export interface IChessMessageHostCommand {
  command: EChessHostCommand
  handicap?: number
  moveTime?: number
  message?: string
}

export enum EChessHostCommand {
  Reset = 1,
  GameStart = 2,
  Message = 3,
  Handicap = 4,
  MoveTime = 5,
}

export const messageId = EChessMessage.HostCommand

export function write(m: IMessageWriter, d: IChessMessageHostCommand) {
  messageWriter.write8(m, messageId)
  messageWriter.write8(m, d.command)
  messageWriter.write16(m, d.handicap || 0)
  messageWriter.writeFloat(m, d.moveTime || 0)
  messageWriter.writeString(m, d.message || '')
}

export function read(m: IMessageWriter) {
  let t = messageWriter.read8(m)
  assert.eq(t, messageId)

  let d: IChessMessageHostCommand = {
    command: messageWriter.read8(m),
    handicap: messageWriter.read16(m),
    moveTime: messageWriter.readFloat(m),
    message: messageWriter.readString(m),
  }
  return d
}

export function test() {
  let ex: IChessMessageHostCommand = {
    command: EChessHostCommand.Reset,
    handicap: 545,
    message: 'hello, world',
    moveTime: 12.4,
  }
  messageWriter.test('host-command', ex, write, read)
}

export function process(m: IMessageWriter, isFromHost: boolean) {
  let msg = read(m)
  if (websockets.testRequiredFromHost(isFromHost, m, messageId)) {
    return
  }

  // console.log('!! HOST COMMAND', msg.command)
  if (msg.command === EChessHostCommand.Reset) {
    chessGameMode_game.signalReset()
  }
  if (msg.command === EChessHostCommand.GameStart) {
    chessGameMode_game.signalGameStarted()
  }
  if (msg.command === EChessHostCommand.Message) {
    chessUiGame.setMessage(msg.message || '')
  }
  if (msg.command === EChessHostCommand.Handicap) {
    chessGameManager.setHandicap(msg.handicap || 0)
  }
  if (msg.command === EChessHostCommand.MoveTime) {
    chessGameRules.setNormal()
    chessGameRules.setMoveTime(msg.moveTime || 0)
  }
}

export function sendMessageAndImmediatelyExecute(
  msg: IChessMessageHostCommand,
) {
  if (!websockets.getIsHost()) {
    console.error('trying to send host command when not host', msg.command)
    return
  }
  websockets._sendMessageAndImmediatelyExecute(write, msg)
}

export function sendMessageWorldState(
  msg: IChessMessageHostCommand,
  multiId: number,
) {
  websockets._sendMessageWorldState(write, msg, multiId)
}

export function sendText(msg: string) {
  if (websockets.getIsHost()) {
    sendMessageAndImmediatelyExecute({
      command: EChessHostCommand.Message,
      message: msg,
    })
  }
}

export function sendToOthers(msg: IChessMessageHostCommand) {
  websockets._sendMessageToOthers(write, msg)
}
